<template>
    <div class="container">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <p class="heading has-text-weight-bold is-size-5">Users</p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="columns"  style="justify-content: right;">
                            <div class="column has-text-right">
                                <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                                    <div class="tooltiptext">
                                        <ul style="list-style: disc outside">
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can see Web Users.</p>
                                            </li>
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can update the user</p>
                                            </li>
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can define a user role.</p>
                                            </li>
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">You can active/deactivate the user.</p>
                                            </li>
                                            <li style="margin-left: 20px">
                                                <p style="margin-bottom: 10px">Special permissions can be assigned to the user or removed with the Edit button</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="user-table">
            <table class="table is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Is Active</th>
                    <th>Role</th>
                    <th>Act</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in this.userList" :key="user.id">
                    <td>{{user.id}}</td>
                    <td>{{user.fullName}}</td>
                    <td>{{user.email}}</td>
                    <td>
                            <div class="field is-horizontal">
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <label class="radio" v-if="user.id != null">
                                                <input @change="tryChangeUserActiveStat(user)" type="radio" :name="'IsActive'+user.id" v-model="user.isActive" v-bind:value="true">
                                                True
                                            </label>

                                            <label class="radio" v-if="user.id != null">
                                                <input @change="tryChangeUserActiveStat(user)" type="radio" :name="'IsActive'+user.id" v-model="user.isActive" v-bind:value="false">
                                                False
                                            </label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                    </td>

                    <td>
                        <select class="role-selected" @change="tryUpdateUserRole($event.target.value,user.id,user.name)">
<!--                            <option selected>{{user.name}}</option>-->
                            <option :selected="user.name ===role.name" v-for="role in userRoles" :key="role.id" :value="role.id" id="userRole">
                                <span>{{role.name}}</span>
                            </option>
                        </select>
                    </td>

                    <td>
                        <button title="Edit" class="button is-small is-light is-info"
                                @click="tryEditUserInfoModal(user.id)">
                            <font-awesome-icon icon="edit"/>
                            Edit
                        </button>
                    </td>

                </tr>
                </tbody>
            </table>
        </div>
        <div class="modal" :class="{'is-active':isActiveUserModal}">
            <div class="modal-background" @click="isActiveUserModal=false"></div>
            <div class="modal-card animate__animated animate__zoomIn animate__faster" style="height: 50%;width: 40%">
                <header class="modal-card-head">
                    <p class="modal-card-title">Edit User Info</p>
                    <button class="delete" aria-label="close" @click="isActiveUserModal=false"></button>
                </header>
                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column">
                            <article class="message">
                                <div class="message-header">
                                    <p>Allowed Permissions</p>
                                </div>
                                <div class="message-body">
                                    <ul class="list" title="Remove User Permission">
                                        <!-- userPermissions-->
                                        <li class="list-item" v-for="userPermission in filteredAllowedPermission"
                                            :key="userPermission.id"
                                            @click="tryRemoveUserPermission(userPermission.id)"
                                            style="cursor: pointer">
                                            {{userPermission.key}}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                        <div class="column">
                            <article class="message">
                                <div class="message-header">
                                    <p>Not Allowed Permissions</p>
                                </div>
                                <div class="message-body">
                                    <ul class="list" title="Add User Permission">
                                        <li class="list-item" v-for="permission in filteredPermission"
                                            :key="permission.id"
                                            @click="tryAddUserPermission(permission.id)"
                                            style="cursor: pointer">
                                            {{permission.key}}
                                        </li>
                                    </ul>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <!--                    <button class="create-button button" @click="tryEditUserRole()">-->
                    <!--                                  <span class="icon is-small">-->
                    <!--                                     <i class="fas fa-save"></i>-->
                    <!--                                  </span>-->
                    <!--                        <span>Save</span>-->
                    <!--                    </button>-->
                    <button class="button" @click="isActiveUserModal=false">Cancel</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";

    const {mapState, mapActions} = createNamespacedHelpers("users");

    export default {
        name: "UserList",
        data() {
            return {
                isActiveUserModal: false,
                activeUserId: 0,
                userRoleForm: {
                    UserId: 0,
                    RoleId: 1
                },
                userPermissionForm: {
                    UserId: 0,
                    PermissionId: 0,
                    PermissionType: 0
                }
            }
        },
        async created() {
            await this.getUsers();
            await this.getUserRoles();
        },
        methods: {
            ...mapActions([
                "getUsers",
                "getUserRoles",
                "setUserRole",
                "setUserActive",
                "getPermissions",
                "getUserPermissions",
                "setUserPermission"]),

            goToUserDetails(value) {
                this.$router.push({name: 'UserDetails', params: {id: value}});
            },

            async tryUpdateUserRole(roleId, userId, userRole) {
                const selectedRole = this.userRoles.find(i => i.id == roleId)
                await this.$swal({
                    title: 'Are you sure you want to change the users role:  ' + userRole + ' -> ' + selectedRole.name,
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) => {
                    if (response.value) {
                        this.userRoleForm.RoleId = roleId;
                        this.userRoleForm.UserId = userId;
                        try {
                            await this.setUserRole(this.userRoleForm)

                            this.$notify({
                                title: "Success",
                                text: "You have update user role in successfully.",
                                type: "success"
                            });
                            this.isActiveUserModal = false;
                        } catch (e) {
                            this.$notify({title: "Error", text:"Error on tryUpdateUserRole function. e: "+ e.message, type: "error"})
                        }
                    }
                });

                await this.getUsers();
                await this.getUserRoles();

            },

            async tryEditUserInfoModal(value) {
                this.isActiveUserModal = true;
                this.activeUserId = value;
                await this.getUserRoles();
                await this.getUserPermissions(value);
                await this.getPermissions();
            },

            async tryChangeUserActiveStat(user)
            {

                await this.$swal({
                    title: 'Are you sure you want to change the active stat of:  ' + user.fullName + ' -> ' + user.isActive,
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) => {
                    if (response.value) {

                        try {
                            await this.setUserActive(user);

                            this.$notify({
                                title: "Success",
                                text: "You have update user active stat in successfully.",
                                type: "success"
                            });

                        } catch (e) {
                            this.$notify({title: "Error", text:"Error on tryChangeUserActiveStat function e: "+ e.message, type: "error"})
                        }
                    }
                });

                await this.getUsers();
                await this.getUserRoles();

            },

            async tryAddUserPermission(value) {
                await this.$swal({
                    title: 'Are you sure add permission',
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) => {
                    if (response.value) {
                        this.userPermissionForm.PermissionId = value;
                        this.userPermissionForm.UserId = this.activeUserId;
                        this.userPermissionForm.PermissionType = 1;
                        await this.setUserPermission(this.userPermissionForm);
                    }
                });
            },

            async tryRemoveUserPermission(value) {
                await this.$swal({
                    title: 'Are you sure remove permission',
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    cancelButtonColor: '#C5381A',
                    confirmButtonColor: '#1874DA',
                    confirmButtonText: 'Yes',
                }).then(async(response) => {
                    if (response.value) {
                        this.userPermissionForm.PermissionId = value;
                        this.userPermissionForm.UserId = this.activeUserId;
                        this.userPermissionForm.PermissionType = 0;
                        await this.setUserPermission(this.userPermissionForm)
                    }
                });
            },

            async tryEditUserRole() {
                this.userRoleForm.UserId = this.activeUserId;
                try {
                    await this.setUserRole(this.userRoleForm);
                    this.$notify({
                        title: "Success",
                        text: "You have update role in successfully.",
                        type: "success"
                    });
                    this.isActiveUserModal = false;
                } catch (e) {
                    this.$notify({title: "Error", text: e.message, type: "error"})
                }
            }
        },

        computed: {
            ...mapState([
                "userList",
                "userRoles",
                "permissions",
                "userPermissions"]),

            filteredPermission: function () {
                return this.permissions.filter(i => !this.userPermissions.find(j => j.id == i.id))
            },

            filteredAllowedPermission : function(){
                return this.permissions.filter(i => this.userPermissions.find(j => j.id == i.id))
            },

        }
    }

</script>

<style scoped>
    .user-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    .user-table td {
        border: 0px;
    }

    .user-table {
        overflow-y: scroll;

        height: 790px;
    }

    .user-table th {
        top: -12px;
        position: sticky;
        background-color: white;
        z-index: 2;
    }

    .user-menu {
        background-color: #fff;
        /*border-radius: 6px;*/
        box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
        color: #4a4a4a;
        display: block;
        padding: 1.25rem;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .role-selected {
        border: 0;
        cursor: pointer;
        font-size: 1em;
        font-family: Arial;
        position: relative;
    }

    .role-selected option {
        background-color: #6a85a7;
        color: white;
        font-family: sans-serif;
        font-style: unset;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 99;
        position: absolute;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
